// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, Fragment, useEffect, useRef} from 'react';
import cn from 'classnames';
import etask from 'zetask';
import {Settings_context} from '../../../../../hola/pub/settings_ctx';
import {Button} from '../../../../../hola/pub/lib/button';
import {use_translation_v} from '../../../../../hola/pub/lib/trans_v';
import {use_app_context} from '../../../lib/app_context';
import {Modal} from '../../../../../hola/pub/lib/modal';
import {get_email, use_disappear} from '../utils';
// @ts-ignore
import SumsubWebSdk from '@sumsub/websdk-react';
import {t_kyc_status} from '../../../lib/use_kyc';
import Icon_warn from '../../../img/icons/12/warn.svg';
import Icon_pending from '../../../img/icons/12/pending.svg';
import Icon_success from '../../../img/icons/12/success.svg';
import Icon_error from '../../../img/icons/12/error.svg';
import Icon_close from '../../../img/icons/16/close.svg';
import Icon_check from '../../../img/icons/16/check.svg';
import {perr} from 'hola_pub_util';
import {use_qs_with_set} from '../../../../../hola/pub/lib/use_qs';

import styles from './kyc.module.less';

export const show_kyc_btn_statuses: t_kyc_status[] =
    ['init', 'retry', 'rejected'];
const kyc_statuses_pending: t_kyc_status[] = ['pending', 'pre_approved'];

type t_kyc_account = {
    button_text?: string;
    show_title_kyc?: boolean;
    on_login?:(event)=>void
};

export const Kyc_account = ({button_text = 'Start process',
  show_title_kyc = false, on_login}: t_kyc_account)=>{
    const {theme} = useContext(Settings_context);
    const {T, t} = use_translation_v({no_defaults: true});
    const {user, kyc} = use_app_context();
    const handle_kyc_click = (event: React.MouseEvent<HTMLButtonElement>)=>{
      if (user)
        kyc.start_kyc_process();
      else if (on_login)
        on_login(event);
      else
        kyc.start_kyc_process();
    };
    return <Fragment>
      {show_title_kyc ?
        <p className={
          cn(theme.color_n700, theme.med, theme.p16, styles.title)}>
          <T>KYC</T></p>
      :null}
      <div className={cn(styles.details_container)}>
        {show_kyc_btn_statuses.includes(kyc.info.status) &&
        <Button color="white" size='sm'
          caption={t(button_text)}
          inline round={false}
          on_click={handle_kyc_click}
        />}
        {kyc_statuses_pending.includes(kyc.info.status) &&
          <p className={cn(theme.p14, theme.color_n700)}>
            KYC pending for email:
            <span className={theme.bold}> {user.kyc_pre_approved_email}</span>
          </p>}
        {kyc.info.status == 'completed' &&
          <p className={cn(theme.p14, theme.color_n700)}>
            KYC passed with email:
            <span className={theme.bold}> {user.kyc_approved_email}</span>
          </p>}
      </div>
    </Fragment>;
};

interface i_kyc__button_props {
    site: string;
    caption: string;
    color: 'black' | 'white';
    size?: 'sm' | 'md' | 'lg';
    cls?: string;
    on_verify_click?: ()=>void;
}
export const Kyc_button = (props: i_kyc__button_props)=>{
    const {t} = use_translation_v({no_defaults: true});
    const {kyc} = use_app_context();
    return show_kyc_btn_statuses.includes(kyc.info.status) &&
      <Button color={props.color} size={props.size ?? 'sm'}
        caption={t(props.caption)} cls={props.cls}
        inline round={false}
        on_click={()=>{
          props.on_verify_click?.();
          kyc.start_kyc_process();
        }} />;
};

export const Kyc_modal = ({site}: {site: string})=>{
    const {user, kyc} = use_app_context();
    const email = get_email(user);
    const {qs, set_qs} = use_qs_with_set();
    const on_close = ()=>{
        kyc.check_status();
        kyc.clear_token();
        set_qs({start_kyc: null});
    };
    useEffect(()=>{
        if (qs.start_kyc)
            kyc.start_kyc_process();
    }, [qs.start_kyc]);
    const access_token_expiration_handler = ()=>etask(function*(){
        return yield kyc.start_kyc_process();
    });
    return kyc.info.token && <Modal is_open={true}
      content_cls={styles.kyc_modal}
      on_close={on_close} width={800}>
      <SumsubWebSdk accessToken={kyc.info.token}
        expirationHandler={access_token_expiration_handler}
        config={{
          lang: 'en', email, theme: 'light',
          customizationName: site
        }}
        options={{}}
        onMessage={msg=>{
          console.log('kyc message: ', msg);
          if (msg == 'idCheck.onApplicantSubmitted')
          {
            perr({
              id: site+'_kyc_submitted',
              info: {hola_uid: user.hola_uid, email}
            });
            kyc.check_status();
          }
          if (msg == 'idCheck.onApplicantReviewed')
            kyc.check_status();
        }}
        onError={d=>console.log(d)}
      />
    </Modal>;
};

interface i_kyc_block_props {
    site: string;
    caption: string;
    btn_color: 'black' | 'white';
    cls?: string;
    on_ok: ()=>void;
}
export const Kyc_block = (props: i_kyc_block_props)=>{
  const {theme} = useContext(Settings_context);
  const {kyc} = use_app_context();
  return <div
    className={cn(styles.kyc_block, kyc.is_pending && styles.pending)}>
    <p className={cn(theme.p14, theme.med, theme.color_n700)}>
      {kyc.is_pending
        ? `Your proxies will be ready within one business day
        following KYC approval`
        : `To use your proxies, please verify your identity
        by completing your KYC process.`}
    </p>
    <Kyc_button color={props.btn_color} site={props.site}
      caption={props.caption} />
    {kyc.is_pending && <Button color='transparent' size='sm'
      inline round={false} caption={'Got it'} on_click={props.on_ok} />}
  </div>;
};

interface kyc_status_item {
    icon: React.ReactNode;
    caption: string;
}
const kyc_status: Record<t_kyc_status, kyc_status_item | null> = {
    init: {
        icon: <Icon_warn />,
        caption: 'KYC verification required',
    },
    pending: {
        icon: <Icon_pending />,
        caption: 'Pending final approval',
    },
    pre_approved: {
        icon: <Icon_pending />,
        caption: 'Pending final approval',
    },
    completed: {
        icon: <Icon_success />,
        caption: 'Verification Approved',
    },
    rejected: {
        icon: <Icon_error />,
        caption: 'Proxies were disabled',
    },
    retry: {
        icon: <Icon_warn />,
        caption: 'Please retry KYC verification',
    },
};

export const Maybe_kyc_subtitle = ({type} :{type: string})=>{
    const {theme} = useContext(Settings_context);
    const {kyc} = use_app_context();
    if (type != 'events_resi_group')
        return null;
    return <span
      className={cn(styles.table_header_kyc_subtitle,
        kyc.info.status == 'completed' && styles.success,
        kyc.info.status == 'rejected' && styles.error,
        theme.P, theme.p12)}>
      {kyc_status[kyc.info.status]?.icon}
      {kyc_status[kyc.info.status]?.caption}
    </span>;
};

export const Top_kyc_message = ()=>{
    const {theme} = useContext(Settings_context);
    const {visible, show} = use_disappear(5);
    const {kyc} = use_app_context();
    const {status} = kyc.info;
    const prev_status = useRef(status);
    useEffect(()=>{
        if (['rejected', 'completed'].includes(status)
            && prev_status.current != 'init' && prev_status.current != status)
        {
            show();
        }
        prev_status.current = status;
    }, [status]);
    if (!visible)
        return null;
    return (
      <div className={styles.top_tooltip}>
        <div
          className={cn(styles.icon,
            status == 'completed' && styles.success,
            status == 'rejected' && styles.error)}>
          {status == 'rejected' && <Icon_close />}
          {status == 'completed' && <Icon_check />}
        </div>
        <div>
          <p className={cn(theme.p16, theme.bold)}>
            {status == 'rejected' && 'KYC Verification wasn’t approved'}
            {status == 'completed' && 'Verification Approved'}
          </p>
          <p className={cn(theme.p14, theme.color_n600)}>
            {status == 'rejected' && `Your proxies will be disabled and
              you'll get a refund within 2 business days`}
            {status == 'completed' && `Your proxies are now ready to use`}
          </p>
        </div>
      </div>
    );
};
